module.exports = __webpack_public_path__ + "static/media/desktop-frame-about-3.9f4f40da.png";